import React from "react";
import {
  tipsLog1,
  tipsLog10,
  tipsLog11,
  tipsLog12,
  tipsLog13,
  tipsLog14,
  tipsLog15,
  tipsLog16,
  tipsLog17,
  tipsLog2,
  tipsLog3,
  tipsLog4,
  tipsLog5,
  tipsLog6,
  tipsLog7,
  tipsLog8,
  tipsLog9,
} from "./logoImports";
import "./index.scss";

const AllTips = () => {
  return (
    <>
      
      <div className="grid-container">
        <a href="/js" rel="noreferrer">
          <img
            className="small-image "
            rel="tips-logo"
            src={tipsLog1}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog2}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image item-3"
            rel="tips-logo"
            src={tipsLog3}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog4}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog5}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog6}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog7}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog8}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog9}
            alt="javascript"
          />
        </a>

        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog10}
            alt="javascript"
          />
        </a>
        
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog11}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog12}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog13}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog14}
            alt="javascript"
          />
        </a>
        
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog15}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog16}
            alt="javascript"
          />
        </a>
        <a href="/angularTips" rel="noreferrer">
          <img
            className="small-image"
            rel="tips-logo"
            src={tipsLog17}
            alt="javascript"
          />
        </a>
      </div>
    </>
  );
};

export default AllTips;
